export default __webpack_public_path__ + "static/media/mariana.573a3cf8.jpg";